import { EventEmitter, Injectable, Input, Output } from '@angular/core';
import { ConfigService } from '@app/app-config.service';
import { NgxUiLoaderConfig, NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable()
export class LoaderService {
  config: NgxUiLoaderConfig;
  /**
   * Constructor
   */
  constructor(private ngxUiLoaderService: NgxUiLoaderService,
     private configService: ConfigService,
     ) {
    
    this.config = this.configService.get('loader');
    // this.config = this.ngxUiLoaderService.getDefaultConfig();
  }
  start() {
    this.ngxUiLoaderService.start();
  }
  stop() {
    this.ngxUiLoaderService.stop();
  }
  
}
